// removed by extract-text-webpack-plugin
module.exports = {"breadcrumb":"breadcrumb__1iZcX"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/loggedOut/style.scss
// module id = 284
// module chunks = 0